import type { FixedProductInput } from '@vy/types';
import { isNotEmptyArray, isNotNullOrUndefined, withDefault } from '@vy/utils';
import React from 'react';
import type { FieldPath, UseFormGetValues } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { VyTooltip } from '../../../../../../components/new-design/VyTooltip';
import { VayuChip } from '../../../../../../components/design/vayu-theme-components/VayuChip';
import { useDialog } from '../../../../../../hooks/use-dialog';
import type { NewPlanForm } from '../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { FieldPathMetadata } from '../../FixedChargesEditTable/fixed-charges-edit-table-types/field-path-metadata';
import { ModifyButton } from '../../ModifyButton';
import { PromotionChargeEditDrawer } from '../../PromotionChargeEditDrawer/PromotionChargeEditDrawer';

type PromotionChargeAddonsCellProps = {
  promotion: FixedProductInput;
};

export const PromotionChargeAddonsCell: React.FC<PromotionChargeAddonsCellProps> = ({ promotion }) => {
  const { isDialogOpen: isDrawerOpen, handleOpen, handleClose } = useDialog();
  const { getValues } = useFormContext<PlanInputForm, NewPlanForm>();
  const promotions = withDefault(getValues('promotionProducts'), []);
  const promotionIndex = promotions.findIndex(({ id }) => id === promotion.id);

  const addedFieldsLabels = getAdjustedAddedFieldsLabels(promotion, promotionIndex, getValues);

  if (isNotEmptyArray(addedFieldsLabels)) {
    return (
      <>
        <div className="flex gap-x-1">
          {addedFieldsLabels.map(({ label, tooltip }) =>
            isNotNullOrUndefined(tooltip) ? (
              <VyTooltip tooltipContent={tooltip.title} key={label} placement="top" arrow>
                <VayuChip label={label} onClick={handleOpen} />
              </VyTooltip>
            ) : (
              <VayuChip key={label} label={label} onClick={handleOpen} />
            ),
          )}
        </div>

        <PromotionChargeEditDrawer open={isDrawerOpen} onClose={handleClose} promotion={promotion} />
      </>
    );
  }

  return (
    <>
      <ModifyButton isDialogOpen={isDrawerOpen} handleOpen={handleOpen} />

      <PromotionChargeEditDrawer open={isDrawerOpen} onClose={handleClose} promotion={promotion} />
    </>
  );
};

function getAdjustedAddedFieldsLabels(
  promotion: FixedProductInput,
  promotionIndex: number,
  getValues: UseFormGetValues<PlanInputForm>,
) {
  const addedFieldsLabels = getAddedFieldsPathMetadata(promotion, promotionIndex, getValues);

  if (addedFieldsLabels.length > 2) {
    return [
      ...addedFieldsLabels.slice(0, 2),
      {
        path: '' as FieldPath<FixedProductInput>,
        label: '+1',
      },
    ] satisfies FieldPathMetadata<FixedProductInput>[];
  }

  return addedFieldsLabels;
}

// TODO: Support this
function getAddedFieldsPathMetadata(
  promotion: FixedProductInput,
  promotionIndex: number,
  getValues: UseFormGetValues<PlanInputForm>,
) {
  return [];

  const fieldsPathsWithLabels = getFieldsPathsWithLabels(promotion, promotionIndex, getValues);

  return fieldsPathsWithLabels;

  // return fieldsPathsWithLabels.filter(({ path }) => {
  //   const value = getValues(`variants.${promotionIndex}.${path}`);

  //   return isNotNullOrUndefined(value);
  // });
}

function getFieldsPathsWithLabels(
  _promotion: FixedProductInput,
  _promotionIndex: number,
  _getValues: UseFormGetValues<PlanInputForm>,
): FieldPathMetadata<FixedProductInput>[] {
  return [];
}
